module.exports = __webpack_public_path__ + "img/solarroof.85e0fd4.jpg";